import { render } from "./SelectionTwoComponent.vue?vue&type=template&id=4b5a0478&scoped=true"
import script from "./SelectionTwoComponent.vue?vue&type=script&lang=js"
export * from "./SelectionTwoComponent.vue?vue&type=script&lang=js"

import "./SelectionTwoComponent.vue?vue&type=style&index=0&id=4b5a0478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5a0478"]])

export default __exports__